export default __webpack_public_path__ + "bc465f51c3fe143672d7300f1bd09267.png";